import React from 'react';

import {ButtonStyle} from 'ui-library/buttons/Button';
import Modal from 'ui-library/modals/Modal';

interface AbandonPlateMapConfirmationModalProps {
  onRequestClose: () => void;
  onRequestSubmit: () => void;
  title: string;
  confirmButtonText: string;
}

export default function AbandonPlateMapConfirmationModal({
  onRequestClose,
  onRequestSubmit,
  title,
  confirmButtonText,
}: AbandonPlateMapConfirmationModalProps): JSX.Element {
  return (
    <Modal
      buttons={[
        {
          text: 'Leave without saving',
          submit: true,
          style: ButtonStyle.TERTIARY_GRAY,
        },
        {text: confirmButtonText, cancel: true, style: ButtonStyle.PRIMARY},
      ]}
      onRequestClose={onRequestClose}
      onRequestSubmit={onRequestSubmit}
      title={title}
    >
      If you leave, any changes you've made will not be saved.
    </Modal>
  );
}
